import React, { MouseEvent } from 'react';
import { FaChartPie } from 'react-icons/fa';

interface CardProps {
  start: string | null;
  end: string | null;
  selected?: boolean;
  status?: string;
  onClick?: Function;
}

const ReportCard: React.FC<CardProps> = ({ start, end, selected, status, onClick }) => {
  const FaChartPieIcon = FaChartPie as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const isClicable = status === 'success';
  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onClick) onClick();
  };
  const bgColor = status === 'pending' ? 'yellow' : status === 'success' ? 'green' : 'red';

  return (
    <>
      <button
        className={`relative w-56 my-2 bg-gradient-to-br rounded-lg border p-4 shadow-lg bg-white disabled:text-light-gray disabled:shadow-sm disabled:bg-light-gray disabled:bg-opacity-5 disabled:cursor-not-allowed group ${
          selected ? 'bg-gray bg-opacity-20' : ''
        }`}
        onClick={handleClick}
        disabled={!isClicable}
      >
        <div
          className="w-3 h-3 absolute top-2 right-2 rounded-full peer cursor-help border border-light-gray"
          style={{
            backgroundColor: bgColor
          }}
        ></div>
        <p className="text-black text-md group-disabled:text-light-gray">{start}</p>
        <p className="text-black text-md text-center group-disabled:text-light-gray">to</p>
        <p className="text-black text-md group-disabled:text-light-gray">{end}</p>
        <div className="absolute bottom-2 right-2">
          <FaChartPieIcon />
        </div>
      </button>
    </>
  );
};

export default ReportCard;
